<div class="p-10 h-full">
    <nz-page-header
        class="text-[16px] font-semibold p-0 pb-2 m-0"
        nzTitle="Pantallas"
    >
        <nz-page-header-extra>
            <nz-space>
                @if (canCreate()) {
                    <button class="button primary-button" (click)="create()">
                        Añadir
                    </button>
                }
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>

    <nz-table
        #nestedTable
        [nzData]="screens"
        nzTableLayout="auto"
        nzSize="small"
        [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate"
        [nzBordered]="true"
    >
        <thead>
            <tr>
                <th nzWidth="300px" id="name">Nombre</th>
                <th nzWidth="300px" id="ip">Dirección IP</th>
                @if (canRead() || canEdit() || canDelete()) {
                    <th nzWidth="200px" id="actions">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of nestedTable.data; track data) {
                <tr>
                    <td>{{ data.name }}</td>
                    <td>{{ data.ip }}</td>
                    @if (canRead() || canEdit() || canDelete()) {
                        <td>
                            <div class="flex align-middle justify-center">
                                @if (canRead()) {
                                    <button
                                        nz-button
                                        nzType="text"
                                        nzShape="circle"
                                        class="table-icon"
                                        [nzTooltipTitle]="'Ver pantalla'"
                                        nzTooltipPlacement="bottom"
                                        nz-tooltip
                                        (click)="view(data)"
                                    >
                                        <span nz-icon nzType="eye"></span>
                                    </button>
                                    @if (canEdit() || canDelete()) {
                                        <nz-divider
                                            nzType="vertical"
                                        ></nz-divider>
                                    }
                                }

                                @if (canEdit()) {
                                    <button
                                        nz-button
                                        nzType="text"
                                        nzShape="circle"
                                        class="table-icon"
                                        [nzTooltipTitle]="'Editar pantalla'"
                                        nzTooltipPlacement="bottom"
                                        nz-tooltip
                                        (click)="edit(data)"
                                    >
                                        <span nz-icon nzType="edit"></span>
                                    </button>
                                    @if (canDelete()) {
                                        <nz-divider
                                            nzType="vertical"
                                        ></nz-divider>
                                    }
                                }

                                @if (canDelete()) {
                                    <button
                                        nz-button
                                        nzType="text"
                                        nzShape="circle"
                                        class="table-icon"
                                        [nzTooltipTitle]="'Eliminar pantalla'"
                                        nzTooltipPlacement="bottom"
                                        nz-tooltip
                                        (click)="delete(data)"
                                    >
                                        <span nz-icon nzType="delete"></span>
                                    </button>
                                }
                            </div>
                        </td>
                    }
                </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer
    [nzClosable]="false"
    [nzVisible]="drawerVisible"
    nzPlacement="right"
    [nzTitle]="title"
    [nzFooter]="footer"
    (nzOnClose)="closeDrawer()"
    [nzPlacement]="
        innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right' : 'bottom'
    "
    [nzWidth]="'500px'"
    [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly"
>
    <ng-template
        #title
        class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly"
    >
        <div style="display: flex; align-items: center">
            <p class="drawer-title">{{ drawerTitle }}</p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form
            nz-form
            [nzLayout]="'vertical'"
            [formGroup]="validateForm"
            (ngSubmit)="submitForm()"
        >
            <div
                nz-row
                [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
                class="p-4"
            >
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired> Nombre </nz-form-label>
                    <nz-form-control
                        nzErrorTip="Indique un nombre para la pantalla"
                    >
                        <input
                            onfocus="select()"
                            nz-input
                            placeholder="Indique un nombre para la pantalla"
                            type="text"
                            id="name"
                            formControlName="name"
                        />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired> Dirección IP </nz-form-label>
                    <nz-form-control
                        nzErrorTip="Indique una dirección IP válida para la pantalla"
                    >
                        <input
                            onfocus="select()"
                            nz-input
                            placeholder="Indique una dirección IP para la pantalla"
                            type="text"
                            id="ip"
                            formControlName="ip"
                        />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label> Usuarios </nz-form-label>
                    <nz-form-control>
                        <nz-select
                            nzMode="multiple"
                            [nzMaxTagCount]="2"
                            [nzMaxTagPlaceholder]="tagPlaceHolder"
                            nzMode="multiple"
                            nzPlaceHolder="Indique los usuarios que tendrán acceso a la pantalla"
                            id="users"
                            [compareWith]="compareUserFn"
                            formControlName="users"
                            [nzDisabled]="fieldsReadOnly"
                        >
                            @for (user of users; track user.id) {
                                <nz-option
                                    [nzLabel]="user.name"
                                    [nzValue]="user"
                                ></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList
                            >y {{ selectedList.length }} más
                            seleccionados</ng-template
                        >
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label> Máquinas vinculadas </nz-form-label>
                    <nz-form-control>
                        <nz-transfer
                            class="mb-5"
                            [nzDataSource]="machinesTransferItems"
                            [nzDisabled]="fieldsReadOnly"
                            [nzTitles]="['Maq.Disponible', 'Maq.Actuales']"
                            nzShowSearch
                        >
                        </nz-transfer>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelForm()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>
